import {
  BarChart3, CalendarClock, ClipboardCheck, Clock, CreditCard, FileClock, LayoutDashboard, LayoutTemplate, MapPin,
  Landmark, MessageSquare, ScrollText, Settings, Users, Wallet,
} from "lucide-react";
import { AppShell, type NavItem, type NavSection } from "../../components/AppShell";
import { useAuth } from "../../context/AuthContext";

export const ADMIN_SECTIONS: NavSection[] = [
  { key: "views", label: "Views" }, { key: "time", label: "Time" }, { key: "workforce", label: "Workforce" },
  { key: "payroll", label: "Payroll" }, { key: "admin", label: "Admin" },
];

export const ADMIN_NAV: NavItem[] = [
  { to: "/admin", label: "Dashboard", slug: "dashboard", icon: LayoutDashboard, end: true, section: "views" },
  { to: "/admin/timeclock-activity", label: "Live Clock", slug: "timeclock-activity", icon: Clock, section: "views" },
  { to: "/admin/sms-activity", label: "SMS Activity", slug: "sms-activity", icon: MessageSquare, section: "views" },
  { to: "/admin/reports", label: "Reports", slug: "reports", icon: BarChart3, section: "views" },
  { to: "/admin/shift-assignments", label: "Shift Assignments", slug: "shift-assignments", icon: CalendarClock, section: "time" },
  { to: "/admin/timesheets", label: "Timesheets", slug: "timesheets", icon: FileClock, section: "time" },
  { to: "/admin/templates", label: "Templates", slug: "templates", icon: LayoutTemplate, section: "time" },
  { to: "/admin/corrections", label: "Exceptions & Corrections", slug: "corrections", icon: ClipboardCheck, section: "time" },
  { to: "/admin/employees", label: "Employees", slug: "employees", icon: Users, section: "workforce" },
  { to: "/admin/venues", label: "Venues", slug: "venues", icon: MapPin, section: "workforce" },
  { to: "/admin/pay-periods", label: "Pay Periods", slug: "pay-periods", icon: Wallet, section: "payroll" },
  { to: "/admin/payments", label: "Payments", slug: "payments", icon: CreditCard, section: "payroll" },
  { to: "/admin/payment-elections", label: "Payment Methods", slug: "payment-elections", icon: Landmark, section: "payroll" },
  { to: "/admin/audit-log", label: "Audit Log", slug: "audit-log", icon: ScrollText, section: "admin" },
  { to: "/admin/settings", label: "Settings", slug: "settings", icon: Settings, section: "admin" },
];

const BUILT = new Set(["dashboard", "employees", "venues", "shift-assignments", "templates", "sms-activity", "settings",
  "timeclock-activity", "timesheets", "corrections", "pay-periods", "payment-elections", "payments", "reports"]);
export const ADMIN_COMING_SOON = ADMIN_NAV.filter((n) => !BUILT.has(n.slug));

export default function AdminLayout() {
  const { session } = useAuth();
  const admin = session?.admin;
  return (
    <AppShell
      nav={ADMIN_NAV}
      sections={ADMIN_SECTIONS}
      testId="admin-shell"
      homePath="/admin"
      userName={admin?.name ?? "Admin"}
      userEmail={admin?.email ?? ""}
      isDemo={admin?.is_demo ?? false}
      roleLabel="Administrator"
    />
  );
}
